// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".counter-badge[data-v-766f5c7f]{background-color:#ff5649;border-radius:9999px;color:#fff;font-weight:900;line-height:1;padding:.3em .5em;text-align:center}.counter-badge.changed[data-v-766f5c7f]{animation:change-766f5c7f .35s ease-in-out 0s 1 normal none running}@keyframes change-766f5c7f{0%{transform:scale(1)}10%{transform:scale(.85)}60%{transform:scale(1.4)}to{transform:scale(1)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
